import React, { Component } from 'react'
import { Provider, connect } from 'react-redux'
import { AxiosResponse } from "axios"
import trans from "trans"
import store from 'store'

import _find from "lodash/find"
import {
    css,
    modal,
    Icon,
    Theme,
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import { InpaintingGroupType, PositionType, WatermarkGroupImageType, WatermarkGroupType } from "../products/types";

import { URL } from "app/config/api-config";
import { isJson } from "app/helpers/other";
import EditMaskWrapper from "./edit-mask-wrapper";

import {
    deleteWatermarkGroupImage,
} from "app/helpers/api";

import { iconDisabledColor } from "../template-edit/components/tools-panel";
import { stringToHash } from "../shape-edit/forms/helpers";
import { WMProductItemType } from './watermark-groups-add-products';
import { ReduxList } from 'app/types/app-types';
import { WatermarksRenderSvgObjects } from 'products/components/render-objects-helper'

const iconSize = 20
const maxSize = 180

interface Props {
    selectedWatermarkGroupId: number
    updateWatermarkGroups: Function
    watermarkGroups: ReduxList<WatermarkGroupType[]>
}

interface State {
    selectedProducts: WMProductItemType[]
}

class WatermarkGroupsImages extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            selectedProducts: [],
        }
    }

    findGroupById = () => {
        const { selectedWatermarkGroupId, watermarkGroups } = this.props
        return selectedWatermarkGroupId ? _find(watermarkGroups?.data, (watermarkGroup) => watermarkGroup.id === selectedWatermarkGroupId) : null
    }

    showModal = (watermarkGroupImage: WatermarkGroupImageType, idx: number) => {
        const watermarkGroup = this.findGroupById()
        modal({
            overlayClassName: 'watermark-groups-marker-modal',
            style: { maxWidth: '95vw', maxHeight: '80vh', minWidth: '60vw', minHeight: '60vw' },
            message: (close) => <Provider store={store}>
                <EditMaskWrapper
                    isAlt={false}
                    selectedGroupId={watermarkGroup.id}
                    initialIndex={idx}
                    updateWatermarkGroups={this.props.updateWatermarkGroups}
                    close={close}
                />
            </Provider>,
            hideCloseButton: true,
            //onClose: () => console.debug('close marker modal'),
        })
    }

    handleDeleteImage = (i: WatermarkGroupImageType, watermarkGroup: WatermarkGroupType) => {
        //no confirm, FIE-656:
        deleteWatermarkGroupImage(i.id, i.watermark_group_id)
            .then((response: AxiosResponse<any>) => {
                this.props.updateWatermarkGroups()
            })
            .catch(e => {
                console.error('cannot delete image', i.filename)
            })
    }


    render() {
        const watermarkGroup = this.findGroupById()

        return (
            <React.Fragment>
                {watermarkGroup?.images && watermarkGroup.images.map((i, idx) => {
                    const hash = (i.user_set_objects ? stringToHash(i.user_set_objects) : '') + i.image_hash
                    const sourceImageUrl = `${URL.laravelBase}get-wmgroup-image/${watermarkGroup.project_id}/${watermarkGroup.id}/${i.filename}?t=${hash}`
                    const maskedImageUrl = `${URL.laravelBase}get-wmgroup-image-masked/${watermarkGroup.project_id}/${watermarkGroup.id}/${i.filename}?t=${hash}`

                    return <GridCell key={`i${hash}${i.filename}`}>
                        <OneImageGrid>
                            {i.user_set_objects ?
                                <StyledMaskPreviewDiv className={'centering clickable'} onClick={() => this.showModal(i, idx)}>
                                    {renderWatermarkMask(i, sourceImageUrl)}
                                    <Grid className='hidden-preview' cols={'1fr'}>
                                        <GridCell style={{ alignSelf: 'center', textAlign: 'center !important' }}>
                                            <img className={'max-image-size'} src={maskedImageUrl} />
                                        </GridCell>
                                    </Grid>
                                </StyledMaskPreviewDiv> :
                                <div className={'clickable centering'} onClick={() => this.showModal(i, idx)}>
                                    <img className={'checker max-image-size'} src={sourceImageUrl} />
                                </div>
                            }

                            <span className={'delete-button'} title={trans("delete")} onClick={() => this.handleDeleteImage(i, watermarkGroup)}>
                                <Icon type={'trash'} color={'#ffffff'} size={iconSize} />
                            </span>

                            {!i.user_set_objects ?
                                <span className={'triangle-button clickable'} title={trans('no_watermark_mask')} onClick={() => this.showModal(i, idx)}>
                                    <Icon type={'exclamation-triangle'} color={Theme.red} size={iconSize} />
                                </span> :
                                <span className={'check-button'} title={trans('watermark_is_marked')}>
                                    <Icon type={'check'} color={'#ffffff'} size={iconSize} />
                                </span>
                            }

                            <span className={'brush-button'} title={trans("edit")} onClick={() => this.showModal(i, idx)}>
                                <Icon type={'paint-brush'} color={iconDisabledColor} size={iconSize} />
                            </span>
                        </OneImageGrid>
                    </GridCell>
                })}
            </React.Fragment>
        )
    }
}

const StyledMaskPreviewDiv = css('div')({
    position: 'relative',
    textAlign: 'center',
    ' .hidden-preview': {
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: 0,
        transition: '1.1s ease',
        backfaceVisibility: 'hidden',
        textAlign: 'center',
        alignSelf: 'center',
        width: '100%',
        height: '100%',
        background: '#ffffff',
    },
    '&:hover .hidden-preview': {
        opacity: 1,
    },
})

const MAX_IMAGE_SIZE = 140
const MARGINS = 10
const GRID_GAP = 15

export const StyledImages = css('div')({
    textAlign: 'left',
    borderLeft: '0',
    ' > .muk-grid': {
        gridTemplateColumns: `repeat(auto-fit, minmax(${MAX_IMAGE_SIZE + 2 * MARGINS}px, 1fr))`,
        gridGap: `${GRID_GAP}px`,
    },
    ' .muk-gridcell': {
        textAlign: 'left',
        alignSelf: 'center',
    },
    ' .muk-gridcell.centering': {
        textAlign: 'center',
    },
    ' .max-image-size': {
        maxWidth: `${MAX_IMAGE_SIZE}px`,
        maxHeight: `${MAX_IMAGE_SIZE}px`,
    }
})

export const OneImageGrid = css(Grid)({
    height: `${MAX_IMAGE_SIZE + 2 * MARGINS}px`,
    position: 'relative',
    overflow: 'hidden',
    ' .brush-button': {
        position: 'absolute',
        top: '3px',
        right: '3px',
        padding: '1px',
        borderRadius: '3px',
        cursor: 'pointer',
        background: '#efefef',
    },
    ' .delete-button': {
        position: 'absolute',
        bottom: '3px',
        left: '3px',
        padding: '1px',
        borderRadius: '3px',
        cursor: 'pointer',
        background: Theme.red,
    },
    ' .triangle-button, .check-button': {
        position: 'absolute',
        top: '3px',
        left: '3px',
        padding: '1px',
        borderRadius: '3px',
    },
    ' .check-button': {
        background: Theme.green,
    },
    ' .centering': {
        alignSelf: 'center',
        textAlign: 'center',
    },
    ' img.bad-url': {
        width: '110px',
        height: '110px',
    },
    ' .already-used': {
        opacity: .2,
        pointer: 'not-allowed',
    }
}, props => {
    return {
        background: props.dataIsBadUrl ? '#ffffff' : '#f9f9f9',
        boxShadow: props.dataIsBadUrl ? undefined : 'rgb(0 0 0 / 30%) 2px 3px 5px 0px',
        border: !props.dataIsBadUrl ? `1px solid ${props.dataIsSelected ? iconDisabledColor : Theme.steelblue}` : undefined,
    }
})

const StyledSvg = css('svg')({
    width: 'auto',
    height: 'auto',
    maxWidth: `${MAX_IMAGE_SIZE}px`,
    maxHeight: `${MAX_IMAGE_SIZE}px`,
})

export function renderWatermarkMask(product: WatermarkGroupImageType | WMProductItemType, imageUrl: string) {
    const objects = product.user_set_objects && isJson(product.user_set_objects) ? JSON.parse(product.user_set_objects) : []

    return <GridCell key={product.image_or_alt_id} className={'image-item'}>
        <div className={'image centering'} title={`product ${typeof product['product_id'] !== 'undefined' ? product['product_id'] : typeof product['id'] !== 'undefined' ? product['id'] : '?' } ${product['width']}x${product['height']}`}>
            <StyledSvg version="1.1" viewBox={`0 0 ${product.width} ${product.height}`} width={maxSize} height={maxSize} className={'clickable preview-svg'}>
                <g>
                    <image
                        className={'checker'}
                        width={product.width}
                        height={product.height}
                        xlinkHref={imageUrl}
                    />
                    <WatermarksRenderSvgObjects
                        objects={objects}
                        color={Theme.blue}
                        opacity={.8}
                    />
                </g>
            </StyledSvg>
        </div>
    </GridCell>
}

function mapStateToProps(state) {
    return {
        watermarkGroups: state.watermarkGroups,
    }
}

export default connect(mapStateToProps, {

})(WatermarkGroupsImages)


